<div class="meta-info-vertical flex justify-evenly content-stretch items-stretch flex-col">
  @if (conferenceReminderTooltipPreTimestamp) {
    <span [matTooltip]="conferenceReminderTooltipPreTimestamp + (conferenceReminderTooltipTimestamp | date: 'medium')">
      <mat-icon [style.color]="conferenceReminderIconColour">alarm</mat-icon>
    </span>
  }
</div>
